/**
 * @param {any} component
 * @param {string} [defaultName='Component']
 * @returns {string}
 */
function getDisplayName(component) {
  var defaultName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Component';

  var _ref = component || {},
      displayName = _ref.displayName,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? component : _ref$name;

  return String(displayName || name || defaultName);
}

export default getDisplayName;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/utils/getDisplayName.js
// module id = 777
// module chunks = 0